
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacyUrlMobile",
      function () {
        return require("private-next-pages/privacyUrlMobile.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacyUrlMobile"])
      });
    }
  